import { Routes, Route, Navigate, Link } from 'react-router-dom';

import { AuthGate } from '@/auth/AuthGate.tsx';
import { DemoLayout } from '@/layouts/DemoLayout.tsx';
import { UserSettingsProvider } from '@/spaces/settings/UserSettingsProvider.tsx';

import { DemoAgents } from './agents/DemoAgents.tsx';
import { DemoArtifacts } from './artifacts/DemoArtifacts.tsx';
import { DemoSharedKnowledge } from './shared-knowledge/DemoSharedKnowledge.tsx';
import { DemoStateViewer } from './state-viewer/DemoStateViewer.tsx';

export const DemoRoutes = () => {
	return (
		<Routes>
			<Route element={<DemoLayout />}>
				<Route index element={<Navigate to="state-viewer" replace />} />
				<Route
					path="state-viewer"
					element={
						<AuthGate autoRedirect>
							<UserSettingsProvider>
								<DemoStateViewer />
							</UserSettingsProvider>
						</AuthGate>
					}
				/>
				<Route
					path="artifacts"
					element={
						<AuthGate autoRedirect>
							<DemoArtifacts />
						</AuthGate>
					}
				/>
				<Route
					path="agents"
					element={
						<AuthGate autoRedirect>
							<DemoAgents />
						</AuthGate>
					}
				/>
				<Route
					path="shared-knowledge"
					element={
						<AuthGate autoRedirect>
							<DemoSharedKnowledge />
						</AuthGate>
					}
				/>
			</Route>
		</Routes>
	);
};

export const DemoNavLinks = () => (
	<>
		<Link to="/demo/state-viewer" className="text-blue-600 hover:underline">
			State Viewer
		</Link>
		<Link to="/demo/artifacts" className="text-blue-600 hover:underline">
			Artifacts
		</Link>
		<Link to="/demo/agents" className="text-blue-600 hover:underline">
			Agents
		</Link>
		<Link to="/demo/shared-knowledge" className="text-blue-600 hover:underline">
			Shared Knowledge
		</Link>
	</>
);
